module.exports = __webpack_public_path__ + "static/media/BackCircle.75ac6a7a.svg";